// extracted by mini-css-extract-plugin
export default {"wrapper":"_7GYNdT_7zbJj6KruMpd_","iconMenuItem":"o7aGhVZDy8qExsDA1Gn1"};